var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("定价管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageSerch" },
          [
            _c(
              "el-card",
              { staticClass: "box-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "cardTitle" }, [
                      _vm._v("定价列表"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "费用类型" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择类型" },
                                    model: {
                                      value: _vm.ruleForm.type,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "type", $$v)
                                      },
                                      expression: "ruleForm.type",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "任务定价", value: "0" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "临勤邀请奖励",
                                        value: "1",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "公司邀请奖励",
                                        value: "2",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "计费模式" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择模式" },
                                    model: {
                                      value: _vm.ruleForm.model1,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "model1", $$v)
                                      },
                                      expression: "ruleForm.model1",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "小时计费", value: 0 },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "包月计费", value: 1 },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "职业" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择模式" },
                                    on: { change: _vm.zhiyeChange },
                                    model: {
                                      value: _vm.ruleForm.zhiye,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "zhiye", $$v)
                                      },
                                      expression: "ruleForm.zhiye",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" },
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.zhenshu, function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.title,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "职业等级" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择职业等级" },
                                    model: {
                                      value: _vm.ruleForm.dengji,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "dengji", $$v)
                                      },
                                      expression: "ruleForm.dengji",
                                    },
                                  },
                                  _vm._l(_vm.jibie, function (i, i2) {
                                    return _c("el-option", {
                                      key: i2,
                                      attrs: {
                                        label: i.propDesc,
                                        value: i.propValue,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "省" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择省" },
                                    on: { change: _vm.getcity2 },
                                    model: {
                                      value: _vm.ruleForm.province,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "province", $$v)
                                      },
                                      expression: "ruleForm.province",
                                    },
                                  },
                                  _vm._l(_vm.city, function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.adcode,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "城市" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择城市" },
                                    model: {
                                      value: _vm.ruleForm.city,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "city", $$v)
                                      },
                                      expression: "ruleForm.city",
                                    },
                                  },
                                  _vm._l(_vm.city1, function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.adcode,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "任务时间" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择时间" },
                                    model: {
                                      value: _vm.ruleForm.hour,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "hour", $$v)
                                      },
                                      expression: "ruleForm.hour",
                                    },
                                  },
                                  _vm._l(_vm.options, function (item) {
                                    return _c("el-option", {
                                      key: item.propDesc,
                                      attrs: {
                                        label: item.propDesc,
                                        value: item.propValue,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getList()
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                staticStyle: { "margin-bottom": "16px" },
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.add()
                  },
                },
              },
              [_vm._v("添加")]
            ),
            _vm._v(" "),
            _c("TableScrollSlider", {
              attrs: { "table-ref": _vm.$refs.scrollTable },
            }),
            _vm._v(" "),
            _c(
              "el-table",
              {
                ref: "scrollTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "id", label: "编号", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "省市", align: "center", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.provinceCode == 100000
                            ? _c("div", [_vm._v("全国")])
                            : _c("div", [
                                _vm._v(
                                  _vm._s(scope.row.province) +
                                    "-" +
                                    _vm._s(scope.row.city)
                                ),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "employSceneName",
                    label: "用工场景",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "平台服务费", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.platformRatio * 100) + "%"),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "保安公司成本比例",
                    align: "center",
                    width: "100",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(scope.row.bodyguardCompanyCostRate * 100) +
                                "%"
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "保安补贴", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              "￥" +
                                _vm._s(
                                  _vm._f("moneyFormat")(
                                    scope.row.bodyguardSubsidy
                                  )
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "用户补贴", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              "￥" +
                                _vm._s(
                                  _vm._f("moneyFormat")(scope.row.customSubsidy)
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "保安费用", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.type == 0
                            ? _c("span", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(
                                      _vm._f("moneyFormat")(
                                        scope.row.bodyguardsPrice
                                      )
                                    )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.type == 1
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(scope.row.invitationIncome) + "%"
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "用户费用", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.type == 0
                            ? _c("span", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(
                                      _vm._f("moneyFormat")(
                                        scope.row.customPrice
                                      )
                                    )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.type == 1
                            ? _c("span", [_vm._v("无")])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "类型", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.type == 0
                                  ? "任务定价"
                                  : scope.row.type == 1
                                  ? "临勤邀请奖励"
                                  : "公司邀请奖励"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "职业", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.careerTypeName)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "级别", align: "center", width: "150" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [_vm._v(_vm._s(scope.row.levelTypeName))]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "计费模式", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.billingModeName)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "hour", label: "时间", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.type == 1
                            ? _c("span", [_vm._v("无")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.type == 0 && scope.row.hour >= 1
                            ? _c("span", [
                                _vm._v(_vm._s(scope.row.hour) + "小时"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.type == 0 && scope.row.hour < 1
                            ? _c("span", [_vm._v("30分钟")])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "publishTime",
                    label: "发布时间",
                    align: "center",
                    width: "160",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "状态", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.status == 0
                            ? _c("span", { staticClass: "redColor" }, [
                                _vm._v("停用"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 1
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("启用"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "操作",
                    align: "center",
                    width: "180",
                    fixed: "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "disAround" }, [
                            scope.row.status == 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn greenColor1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.stop(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                启用\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.status == 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn redColor1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.stop(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                停用\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n                编辑\n              ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn redColor1",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteItem(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n                删除\n              ")]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.pageSize,
                layout: "total, prev, pager, next,sizes",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticStyle: { margin: "0 auto" },
              attrs: {
                "label-position": "right",
                model: _vm.ruleForm1,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "定价分类", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.ruleForm1.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm1, "type", $$v)
                        },
                        expression: "ruleForm1.type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "任务定价", value: "0" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "临勤邀请奖励", value: "1" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "公司邀请奖励", value: "2" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.ruleForm1.type == "0"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "计费模式", prop: "model" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.ruleForm1.model,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "model", $$v)
                                },
                                expression: "ruleForm1.model",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "包月计费", value: "0" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "小时计费", value: "1" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "职业设定", prop: "zhiye" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              on: { change: _vm.zhiyeChange },
                              model: {
                                value: _vm.ruleForm1.zhiye,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "zhiye", $$v)
                                },
                                expression: "ruleForm1.zhiye",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "全部", value: "0" },
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.zhenshu, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.title, value: item.id },
                                })
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.ruleForm1.zhiye != 0
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "级     别", prop: "jibie" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.ruleForm1.jibie,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm1, "jibie", $$v)
                                    },
                                    expression: "ruleForm1.jibie",
                                  },
                                },
                                _vm._l(_vm.jibie, function (i, i1) {
                                  return _c("el-option", {
                                    key: i1,
                                    attrs: {
                                      label: i.propDesc,
                                      value: i.propValue,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "服务省", prop: "type1" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { "margin-right": "auto" },
                              attrs: { placeholder: "请选择" },
                              on: { change: _vm.cityChange },
                              model: {
                                value: _vm.ruleForm1.type1,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "type1", $$v)
                                },
                                expression: "ruleForm1.type1",
                              },
                            },
                            _vm._l(_vm.city, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.adcode },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.ruleForm1.type1 != "100000"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "服务城市", prop: "select" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { "margin-right": "auto" },
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.ruleForm1.select,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm1, "select", $$v)
                                    },
                                    expression: "ruleForm1.select",
                                  },
                                },
                                _vm._l(_vm.city1, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.adcode,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.ruleForm1.type == "1" || _vm.ruleForm1.type == "2"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.ruleForm1.type == "1"
                            ? "临勤邀请收益"
                            : "公司邀请临勤",
                        prop: "num",
                      },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: "请输入", type: "number" },
                          model: {
                            value: _vm.ruleForm1.num,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "num", $$v)
                            },
                            expression: "ruleForm1.num",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("%")])],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.ruleForm1.type == "0"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "场景", prop: "employScene" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.ruleForm1.employScene,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "employScene", $$v)
                                },
                                expression: "ruleForm1.employScene",
                              },
                            },
                            _vm._l(_vm.tableData1, function (item) {
                              return _c("el-option", {
                                key: item.title,
                                attrs: {
                                  label: item.title,
                                  value: item.propValue,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "定价时间", prop: "time" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.ruleForm1.time,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "time", $$v)
                                },
                                expression: "ruleForm1.time",
                              },
                            },
                            _vm._l(_vm.options, function (item) {
                              return _c("el-option", {
                                key: item.propDesc,
                                attrs: {
                                  label: item.propDesc,
                                  value: item.propValue,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户补贴", prop: "subsidy" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                value: _vm.ruleForm1.subsidy,
                                placeholder: "请输入用户补贴",
                                type: "number",
                              },
                              on: { input: _vm.getPrice1 },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("￥"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "保安补贴", prop: "subsidy1" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                value: _vm.ruleForm1.subsidy1,
                                placeholder: "请输入保安补贴",
                                type: "number",
                              },
                              on: { input: _vm.getPrice2 },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("￥"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户费用", prop: "customPrice" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                value: _vm.ruleForm1.customPrice,
                                placeholder: "请输入用户费用",
                                type: "number",
                              },
                              on: { input: _vm.getPrice },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("￥"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "平台服务费", prop: "proportion1" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                placeholder: "请输入平台服务费",
                                type: "number",
                              },
                              on: { input: _vm.getPrice3 },
                              model: {
                                value: _vm.ruleForm1.proportion1,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "proportion1", $$v)
                                },
                                expression: "ruleForm1.proportion1",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "保安公司成本比例",
                            prop: "bodyguardCompanyCostRate",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                placeholder: "请输入保安公司成本比例",
                                type: "number",
                              },
                              on: { input: _vm.getPrice4 },
                              model: {
                                value: _vm.ruleForm1.bodyguardCompanyCostRate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm1,
                                    "bodyguardCompanyCostRate",
                                    $$v
                                  )
                                },
                                expression:
                                  "ruleForm1.bodyguardCompanyCostRate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "保安定价", prop: "bodyguardsPrice" },
                        },
                        [
                          _c("div", [
                            _vm._v(_vm._s(_vm.priceInfo.bodyguardsPrice || 0)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.resetForm1("ruleForm")
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }